<template>
  <el-container class="page_container">
    <!-- 左侧菜单栏，router="ture"开启菜单路由，按照index跳转，default-active属性用于接收高亮激活的index -->
    <el-container>
      <!-- 内容 -->
      <el-main>
       <!-- 头部 -->
        <el-header class="flexCenter">
            <div class="flexStart">
                <img class="logo" :src="logo" @click="$router.push('/WorkPlat')">
                <ul>
                    <li @click="goSubPage(item,index)" :class="subNum == index?'active':''" v-for="(item,index) in children" :key="index">{{item.menuName}}</li>
                </ul>
            </div>
          <div>
            <el-dropdown trigger="hover">
              <div class="infoBox">
                <img class="headPortrait" src="@/assets/picture/headPortraitA.png">
                <span class="username">{{userInfo.userName}}</span>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click="showPersonInfo">
                  <img width="20" src="@/assets/picture/icon/personaldata_icon.png">
                  <span @click="showPersonInfo">{{$t('managerPage.txt1')}}</span>
                </el-dropdown-item>
                <el-dropdown-item>
                  <img width="20" src="@/assets/picture/icon/changepassword_icon.png">
                  <span @click="showPassword">{{$t("managerPage.txt2")}}</span>
                </el-dropdown-item>
                <el-dropdown-item>
                  <img width="20" src="@/assets/picture/icon/exitsafely_icon.png">
                  <span @click="safeSignOut">{{$t("managerPage.txt3")}}</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div class="infoBox">
                <span class="item-box" @click="goSettingPage">
                    <img width="20" src="@/assets/picture/icon/setting.png">
                </span>
<!--                 <span class="item-box" @click="handleChangeTheme">
                    <img width="20" src="@/assets/picture/icon/tips.png">
                </span> -->
                <span class="item-box" @click="handleCopy">
                    <img width="20" src="@/assets/picture/icon/copyright_icon_2x.png">
                </span>
                <span class="item-box" @click="changeLangage">
                    <img width="20" src="@/assets/picture/icon/language.png">
                </span>
            </div>
          </div>
        </el-header>
        <!-- 内容 -->
        <div class="contentBox" :class="{ 'no-footer': !showFooter }">
            <div class="radiusBox">
                <router-view></router-view>
            </div>
        </div>
      </el-main>
      <!-- 页脚 -->
      <el-footer  v-if="showFooter">
        <div class="footerNav">
          <div class="footerBox"  :style="{width: 5.6 + 12.1 + 5.6 * (realMenuList.length - 1) + (realMenuList.length - 2)*6.1 + 'rem'}">
            <div @click="selectNav(item,index)" v-for="(item,index) in realMenuList" :key="index" 
              :class="index == num?'active':'navItem'">
              <img @click="goPage(item)" :src="item.icon?item.icon:apiUrl + '/'+ item.menuIcon">
              <p @click="goPage(item)">{{item.menuName}}</p>
            </div>
          </div>
        </div>
      </el-footer>
    </el-container>
  </el-container>
</template>
<script>
const noFooterList = []
import {apiUrl,serverUrl} from '@/utils/request';
import { crytoLogin } from "@/plugins/index.js";
import qs from 'qs';
export default {
    data() {
        let userInfo = JSON.parse(localStorage.userInfo)
        return {
          apiUrl,
          serverUrl,
            userInfo,
            type: null,
            username: '',
            userId: '',
            num: -1,
            subNum: -1,
            // 顶部菜单
            children: [],
            //左侧菜单数据
            menuslist: [],
            showFooter: true,
            lang:'cn'
        };
    },
    computed: {
        logo() {
            let logos = {
                'white': require('@/assets/picture/logo_w.png'),
                'black': require('@/assets/picture/logo_w.png'),
            }
            return logos[this.$store.state.theme]
        },
        userMenus() {
            return this.$store.state.userMenus
        },
        realMenuList() {
            let list = [];
            // let { userMenus } = this;
            // this.menuslist.forEach(item => {
            //     let newItem = { ...item, children: [] }
            //     if (item.children) {
            //         item.children.forEach(child => {
            //             if (userMenus.includes(child.menuUrl)) {
            //                 newItem.children.push(child)
            //             }
            //         })
            //     }
            //     if (userMenus.includes(newItem.menuUrl) || newItem.menuUrl == '') {
            //         list.push(newItem)
            //     }
            // })
            let arr = this.menuslist;
            let item = {};
            arr.map(e=>{
              if(e.menuUrl == '/myDoc' || e.menuUrl == '/managementProject' || e.menuUrl == '/userList' || e.menuUrl == '/desktopDot' || e.menuUrl == '/platformMonitoring' || e.menuUrl == '/applicationList'){
                list.push(e);
              }
              if(e.menuName ==this.$t('managerPage.txt4')){
                  item = e;
                  list.unshift(item);
                }
            })
            // if(arr.length>6){
            //   let l = arr.length;
            //   let num = l-6;
            //   list = arr.slice(num,7);
            //   arr.map(e=>{
            //     // if(e.menuName =="返回工作台"){
            //     //   item = e;
            //     //   list.unshift(item);
            //     // }
            //   })
            // }else{
            //   list = arr;
            // }
            return list
        }
    },
    // 渲染前获取数据
    created() {
      this.getMenuTree();
        // this.info();
        // this.getUmsMenuAdminList();
    },
    watch: {
        $route: {
            handler() {
                let path = this.$route.fullPath;
                this.showFooter = !noFooterList.includes(this.$route.path);
                let children = [];
                this.realMenuList.map((e, i) => {
                    if (path == e.path) {
                        children = e.children;
                        this.num = i
                    }
                    e.children && e.children.forEach((item, index) => {
                        if (path.indexOf(item.menuUrl) >= 0) {
                            children = e.children;
                            this.subNum = index
                        }
                    })
                })
                this.children = children;
            },
            immediate: true,
        },
    },
    methods: {
      async getMenuTree() {
			const { data: res } = await this.$http.post("/menu/getUserMenuListTree");
            this.loading = false;
			      if (!res.success) {
			      	return this.$message.error(res.message);
			      }
            each(res.result)
            function each(list) {
                list.forEach(item =>{
                    if(!item.parentId) {
                        item.parentId = '0'
                    }
                    if(item.children && item.children.length == 0) {
                        delete(item.children)
                    }
                    else {
                        item.children && each(item.children)
                    }
                })
            }
			this.menuslist = res.result;
      let item = {
              id: "101",
              // todo
              menuName: this.$t('managerPage.txt4'),
              // menuName: '返回工作台',
              menuUrl: "/workPlat",
              icon: require('@/assets/picture/icon/nava1.png'),
              icon1: require('@/assets/picture/icon/nava12.png'),
          }
          this.menuslist.unshift(item);
          this.menuslist.forEach ((e,i)=>{
            if(e.name == this.$t('managerPage.txt5') || e.name == this.$t('managerPage.txt6') || e.name == this.$t('managerPage.txt7')){
              this.menuslist.splice(i, 1);
            }
          })
          this.menuslist.forEach ((e,i)=>{
            if(e.name == this.$t('managerPage.txt5') || e.name == this.$t('managerPage.txt6') || e.name == this.$t('managerPage.txt7')){
              this.menuslist.splice(i, 1);
            }
          })
          let path = this.$route.path;
          let children = [];
          this.menuslist.map(e=>{
            if(e.menuUrl == path && e.children && e.children.length>0){
              children = e.children;
            }
          })
          this.children = children;
        },
        // 点击跳转
        goPage(item) {
            this.$router.push(item.menuUrl);
        },
        goSubPage(item, index) {
            this.subNum = index;
            this.$router.push(item.menuUrl);
        },
        // 通过底部菜单确定顶部目录
        selectNav(item, index) {
            this.num = index;
            this.subNum = 0;
            this.realMenuList.map(e => {
                if (e.id == item.id) {
                    this.children = e.children;
                }
            })
        },
         // 数据加载(用户管理列表)
        async password(){
          let data = {
            id:window.sessionStorage.getItem("userId"),
            password:crytoLogin(this.editPasswordForm.newPassword).rsaData,
            oldPassword:crytoLogin(this.editPasswordForm.password).rsaData,
          }
          const { data: res } = await this.$http.post("/user/info/update/password?"+qs.stringify(data));
          if(!res.success){
            return this.$message.error(res.message);
          }
          this.dialogFormEditPasswordVisible = false;
          this.$message({
            message: res.message,
            type: 'success'
          });
          this.$router.push("/login");
        },
        async goSettingPage() {
			    const { data: res } = await this.$http.post("/menu/getUserMenuListTree");
			    if (!res.success) {
			    	return this.$message.error(res.message);
			    }
          if(res.result && res.result.length>0){
            localStorage.setItem('subNavIndex', 0);
            res.result.map(e=>{
              if(e.menuName == this.$t('managerPage.txt7') && e.children.length>0){
                this.$router.push(e.children[0].menuUrl);
              }
            })
          }
        },
        // 跳转系统设置页面
        // goSettingPage() {
        //   const originUserMenus = this.$store.state.originUserMenus;
        //   let list = originUserMenus.map(item => item.menuUrl);
        //   if(originUserMenus.find(item => list.includes('/roleManagement'))) {
        //     this.$router.push("/roleManagement");
        //   }
        //   else{
        //     let urls = ['/authManagement', '/logManagement', '/menuManagement', '/themeManagement'];
        //     for(let i = 0; i < urls.length; i++) {
        //       if(list.includes(urls[i])) {
        //         this.$router.push(urls[i]);
        //         return 
        //       }
        //     }
        //   }
        // },
        async logout() {
        },
        // 获取当前登录用户信息
        async info() {
            const { data: res } = await this.$http.get('/dmp-es-admin/ums/user/info');
            if (res.code !== 200)
                return this.$message.error(res.message);
            this.username = res.data.umsUser.nickName;
            this.userId = res.data.umsUser.id;
            localStorage.setItem('curUserId', this.userId);
            this.getUmsUserRoleRlatList();
        },
        // 查询后台菜单列表
        async getUmsMenuAdminList() {
            const { data: res } = await this.$http.get('/dmp-es-admin/ums/umsMenuPortal/getUmsMenuPortalList');
            if (res.code !== 200)
                return this.$message.error(res.message);
        },
        // 获取用户角色关系列表
        async getUmsUserRoleRlatList() {
            const { data: res } = await this.$http.get('/dmp-es-admin/ums/umsUserRoleRlat/getUmsUserRoleRlatList/' + this.userId);
            if (res.code !== 200)
                return this.$message.error(res.message);
        },
        // 显示个人信息
        showPersonInfo() {
            this.infoDetail();
            this.$router.push("/userCenter");
        },
        // 获取用户信息
        async infoDetail() {
            const { data: res } = await this.$http.get('/user/info/detail');
           this.addUserForm = {
                ...res.result
            }
        },
        // 显示密码
        showPassword() {
            this.$router.push("/editPassword");
        },
        // 退出登录
        safeSignOut() {
            this.$confirm('<p class="color666 fz14">'+this.$t('managerPage.txt11')+'</p>', this.$t('managerPage.txt12'), {
                dangerouslyUseHTMLString: true,
                confirmButtonText:this.$t('managerPage.txt8'),
                cancelButtonText: this.$t('managerPage.txt9'),
                type: 'warning',
                center: true
            }).then(() => {
                localStorage.sessionId = '';
                localStorage.userInfo = '';
                this.$message({
                    type: 'success',
                    message: this.$t('managerPage.txt10')
                });
                this.$router.replace('/login')
            }).catch(() => {
            });
        },
        handleChangeTheme() {
            const theme = this.$store.state.theme == 'black' ? 'white' : 'black';
            this.$store.commit('TOGGLE_THEME', theme)
        },
        handleCopy(){
            this.$router.push("/contactPage");
        },
        // 切换语言
        async changeLangage() {
          let lang = localStorage.getItem('language')||'cn';
          if(lang == 'cn'){
            lang = 'en';
          }else{
            lang = 'cn';
          }
           const { data: res } = await this.$http.post('/sysLanguage/setSysLanguage?selected='+lang);
            this.$i18n.locale=lang   //设置中英文模式
            localStorage.setItem('language',lang);
            let path= this.$router.currentRoute.path
             console.log(path,'path')
             if(path == '/receiveShare' || path == '/myShare' ){
               this.subNum= -1;
               this.$router.push("/myDoc"); 
               location.reload();
             }else{
               location.reload();
             }
            // path.value=route.path
            // location.reload();
            // window.sessionStorage.setItem("language", lang);
            let msg= lang == 'cn'?'切换中文成功':'Successfully switched to English'
            this.$message({
                type: 'success',
                message:msg
            });
        },
    }
};
</script>

<style lang="less" scoped>
.page_container {
  height: 100%;
  .logo{
    display: block;
    width: 18.6rem;
    margin-right: 74px;
  }
}
/deep/ .el-dialog{
  /deep/ .el-input,/deep/ .el-input__inner{
    width: 100% !important;
  }
  /deep/ .el-form-item:last-of-type{
    margin-bottom: 0;
  }
  /deep/ .el-dialog .el-dialog__body .el-select .el-input__inner, .el-dialog .el-dialog__body .el-input__inner, .el-dialog .el-dialog__body .el-input{
    border-radius: 8px;
  }
}
.contentBox{
  height: calc(100vh - 19rem);
  overflow: auto;
  background-image: linear-gradient(#1B3B7C, #FFFFFF);
  .radiusBox{
    background: #F4F4F4;
    border-radius: 50px;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    padding:2rem 18rem;
  }
  &.no-footer{
      height: calc(100vh - 12rem);
  }
}
.el-dropdown-menu{
  margin-top: 2rem !important;
  padding:0;
  .popper__arrow{
    display: none !important;
  }
  .el-dropdown-menu__item:hover{
    background: none;
  }
  .el-dropdown-menu__item:hover span{
    background: none;
    color:#1B3B7C;
  }
  .el-dropdown-menu__item{
    padding:1rem 2rem 1rem 1.2rem;
    font-size: 1.5rem;
    color:#1F1D37;
    img{
      width: 2rem;
      margin-right: 1rem;
    }
    span{
      font-size: 1.4rem;
      font-weight: 400;
      color: #666666;
    }
  }
}
.titleSystem{
  margin-bottom: 65px;
  img{
    margin-right: 13px;
    margin-top: -10px;
  }
  span{
    color:#1F1D37;
    font-size: 20px;
    font-weight: 700;
    }
  }
  .signOut{
    position: fixed;
    bottom:6.4rem;
    left: 9.2rem;
  }
  .el-header {
    background: #1B3B7C;
    padding:2.6rem 18rem;
    display: flex;
    height: auto !important;
    /*justify-content: space-between;*/
    align-items: center;
    position: relative;
    .frBox{
      position: absolute;
      right: 5rem;
    }
    ul{
      display: flex;
      .active{
        background: #fff;
        border-radius: 50px;
        color: #1B3B7C;
      }
      .active:after
        {
        content:"";
        display: block;
        width: 4.4rem;
        height: 3.6rem;
        line-height: 3.6rem;
        background: fff;
        border-radius: 8px;
      }
      li{
        display: block;
        border-radius: 50px;
        color: #fff;
        padding:0 2rem;
        cursor: pointer;
        height: 3.6rem;
        line-height: 3.6rem;
      }
    }
    .infoBox{
      float: right;
      .username{
        display:inline-block;
        height: 3.4rem;
        line-height: 3.4rem;
        padding-right:2.4rem;

        color:#fff;
      }
      .headPortrait{
        width: 3.6rem;
        height: 3.6rem;
        min-height: 3.6rem;
        min-width: 3.6rem;
        margin-right: 1rem;
        border-radius: 50%;
      }
      .item-box{
          width: 2.5rem;
          height: 2.5rem;
          min-height: 2.5rem;
          min-width: 2.5rem;
          display: inline-block;
          position: relative;
          margin-top: 0.5rem;
          margin-left: 3.5rem;
            cursor: pointer;
            img{
                width: 2.5rem;
                height: 2.5rem;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
            }
      }
    }
  }
  .el-footer{
    padding:0 0 2rem 0;
    background: #fff;
    height: 10rem !important;
    .footerNav{
      display: inline-block;
      padding: 0.7rem 6rem 0 6rem;
      margin:0 auto;
      background: #FFFFFF;
      border-radius: 2rem;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      .footerBox{
        display: flex;
        .active{
          cursor: pointer;
          margin-right: 6.1rem;
          flex: none;
          img{
            width: 5.6rem;
            height: 5.6rem;
            margin:0 auto;
            margin-bottom: 0.5rem;
            display: block;
          }
          p{
            font-size: 1.4rem;
            color: #222222;
          }
        }
        .active:first-of-type{
          margin-right: 12.1rem;
        }
        .active:last-of-type{
          margin-right: 0;
        }
        .navItem{
          cursor: pointer;
          margin-right: 6.1rem;
          flex: none;
          img{
            width: 5.6rem;
            height: 5.6rem;
            margin:0 auto;
            margin-bottom: 0.5rem;
            display: block;
          }
          p{
            font-size: 1.4rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #222222;
          }
        }
        .navItem:first-of-type{
          margin-right: 12.1rem;
        }
        .navItem:last-of-type{
          margin-right: 0;
        }
      }
    }
  }

  .el-main {
    background: #F4F4F4;
    padding:0;
    min-height: calc(100vh - 120px)
  }
</style>
